<template>
  <div id="app">
    <Header></Header>
    <Block></Block>
    <Footer></Footer>
  </div>
</template>

<script>
//Bootstrap-vueを追加
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Block from "./components/Block.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    Block,
    Header,
    Footer
  },
};
</script>

<style lang="scss">
body {
  position: relative;
  background: #eaeaea;
  font-size: 13px;
  line-height: 1.3;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
